<div class="grid align-content-center">
  <div class="col" style="max-width: 100%">
    @if (datasets$ | async) {
      <p-floatLabel class="mb-4 mt-3">
        <p-select
          [inputId]="datasetSelectorId"
          (onChange)="updateSelectableVersionsAndVariableAndEmmit()"
          [options]="groupedDatasets"
          [(ngModel)]="selectionModel.selectedDataset"
          optionLabel="pretty_name"
          optionGroupLabel="label"
          optionGroupChildren="items"
          [group]="true"
          [filter]="true"
          filterBy="pretty_name"
          [style]="{ width: '100%' }"
        >
          <ng-template let-group #group>
            <div class="flex align-items-center gap-2 group-header">
              <i [class]="group.icon"></i>
              <span>{{ group.label }}</span>
            </div>
          </ng-template>

          <ng-template let-item pTemplate="item">
            <span>{{ item.pretty_name }}</span>
          </ng-template>

          <ng-template let-item pTemplate="selectedItem">
            <span>{{ item.pretty_name }}</span>
          </ng-template>
        </p-select>
        <label for="{{ datasetSelectorId }}">Dataset name</label>
      </p-floatLabel>
    }
  </div>
</div>

<div class="grid align-content-center">
  <div class="col" style="max-width: 100%">
    @if (selectableDatasetVersions$ | async; as selectedVersions) {
      <p-floatLabel class="mb-4">
        <p-select
          [inputId]="versionSelectorId"
          [style]="{ width: '100%' }"
          [options]="selectedVersions"
          [(ngModel)]="selectionModel.selectedVersion"
          optionLabel="pretty_name"
          (onChange)="onVersionChange(selectedVersions)"
        >
          <ng-template let-item pTemplate="item">
            <span
              >{{ item.pretty_name }}
              @if (item.id === newestVersionId) {
                <em class="text-muted"> (newest version)</em>
              }
            </span>
          </ng-template>
          <ng-template let-item pTemplate="selectedItem">
            <span
              >{{ item.pretty_name }}
              @if (item.id === newestVersionId) {
                <em class="text-muted"> (newest version)</em>
              }
            </span>
          </ng-template>
        </p-select>
        <label for="{{ versionSelectorId }}"
          >Dataset version
          @if (newerVersionExists) {
            <span class="warning-text"> (newer version available!) </span>
          }
        </label>
      </p-floatLabel>
    }
  </div>
</div>

<div class="grid align-content-center">
  <div class="col" style="max-width: 100%">
    <p-floatLabel>
      <p-select
        [inputId]="variableSelectorId"
        optionLabel="short_name"
        [style]="{ width: '100%' }"
        [options]="selectableDatasetVariables$ | async"
        [(ngModel)]="selectionModel.selectedVariable"
      >
        <ng-template let-item pTemplate="item">
          <span>
            {{
              item.display_name === "none"
                ? item.pretty_name
                : item.display_name
            }}
            [{{ item.unit ? item.unit : "n.a." }}]
          </span>
        </ng-template>

        <ng-template let-item pTemplate="selectedItem">
          <span>
            {{
              item.display_name === "none"
                ? item.pretty_name
                : item.display_name
            }}
            [{{ item.unit ? item.unit : "n.a." }}]
          </span>
        </ng-template>
      </p-select>
      <label for="{{ variableSelectorId }}">Variable [units]</label>
    </p-floatLabel>
  </div>
</div>
